export const ACTIVATE_SEARCH_EVENT = 'activateSearch';
export const ACTIVATE_FULL_BAR = 'activateFullBar';
